import React, { useEffect, useState } from 'react';
import { goToLink } from '../utils/Functions';
import Button from './bper-button';
import parseHTML from 'html-react-parser';
import iconAreaSelf from './../images/filiali/ICON.svg';


function ResultsItem({
	el,
	stringOpenTime,
	sameLunediVenerdi,
	sameSabatoDomenicaChiuso,
	linkIndicazioniStradali,
	cssClass,
	setMarkerSelected,
	objDistanze,
	configurations,
	currentSubsidiary,
	translations,
	showServiceInfo,
	setShowServiceInfo
}) {
	const [distance, setDistance] = useState(undefined);

	const handleShowServiceInfo = (elementId, e, obj) => {
		e.preventDefault();
		e.stopPropagation();
		let elem = document.querySelector('#' + elementId);
		let rect = elem.getBoundingClientRect();

		const serviceInfo = {
			...obj,
			rect: rect
		}

		console.log(serviceInfo);

		setShowServiceInfo(serviceInfo);
	}

	//distanza dal punto selezionato sulla mappa dalla ricerca (oppure da posizione utente) - distanza "aerea"
	//const distance = (parseFloat(window.google.maps.geometry.spherical.computeDistanceBetween(new window.google.maps.LatLng(place.lat, place.lng), new window.google.maps.LatLng(el.latitude, el.longitude))) / 1000).toFixed(1);

	//NON CANCELLARE - DA RIPRISTINARE - SERVE PER RECUPERARE DISTANZA IN KM! ORA A COMMENTO PER EVITARE TROPPE CHiAMATE
	/*useEffect(() => {
		let ignore = false;
		const service = new window.google.maps.DistanceMatrixService();

		objDistanze &&
			service.getDistanceMatrix(
				{
					origins: [objDistanze.origin],
					destinations: [objDistanze.destination],
					travelMode: 'DRIVING',
					avoidHighways: true,
					avoidTolls: true
				},
				callback
			);

		function callback(response, status) {
			if (!ignore) {
				if (status === 'OK') {
					const element = response?.rows?.[0]?.elements?.[0];
					if (element?.distance) {
						setDistance({
							km: element.distance.text,
							duration: element.duration.text
						});
					}
				}
			}
		}
		return () => {
			ignore = true;
		};
	}, [objDistanze]);*/
	//NON CANCELLARE - DA RIPRISTINARE - SERVE PER RECUPERARE DISTANZA IN KM! ORA A COMMENTO PER EVITARE TROPPE CHiAMATE





	/*async function getDistance() {
		var service = new window.google.maps.DistanceMatrixService();
		service.getDistanceMatrix(
			{
				origins: [objDistanze.origin],
				destinations: [objDistanze.destination],
				travelMode: 'DRIVING',
				avoidHighways: true,
				avoidTolls: true
			},
			callback
		);

		function callback(response, status) {
			status === 'OK' &&
				response.rows &&
				response.rows[0] &&
				response.rows[0].elements &&
				response.rows[0].elements[0] &&
				response.rows[0].elements[0].distance &&
				setDistance({
					km: response.rows[0].elements[0].distance.text,
					duration: response.rows[0].elements[0].duration.text
				});
		}
	}*/
	const stopPropagation = (e) => {
		e && e.stopPropagation();
		e && e.nativeEvent.stopImmediatePropagation();
	}

	const capitalize = (string) => {
		const words = string.split(/([ \-'/0-9]+)/);

		let capitalizedWords = words.map(word => {
			if (!/^[ \-'/0-9]+$/.test(word)) {
				return word.charAt(0).toUpperCase() + word.slice(1);
			}
			return word;
		});

		return capitalizedWords.join('');
	}

	const subsidiaryId = el.id;
	const subsdiaryType = el.subsdiaryType;
	const bankCode = subsdiaryType !== 'CP' ? 'bankCode-0'+`${el.bankCode}` : 'bankCode-cp';
	const cssClassWithBank = `${cssClass}` + ' ' + `${bankCode}` + ' light-neutral-20';
	const cssClassName = 'marker-icon '+`${bankCode}`;

	return (
		<div
			id={subsidiaryId}
			className={cssClassWithBank}
			onClick={() =>
				setMarkerSelected({
					id: el.id,
					lat: el.latitude,
					lng: el.longitude
				})
			}
			data-bankcode={bankCode}
		>
			<div className="store-info | display-flex flex-dir-col justify-content-between">
				<div className="store-info__content">
					{bankCode === 'bankCode-05387' ? (
						<div className="row subsidiary-info-card-type bankCode-05387">{translations.bankName05387}</div>
					) : bankCode === 'bankCode-03084' ?
						(<div className="row subsidiary-info-card-type bankCode-03084">{translations.bankName03084}</div>)
						: (<div
							className="row subsidiary-info-card-type bankCode-cp">{translations.bankNameCP}</div>)
					}
					{el.subsidiaryDescription &&
						<h4 className="store-info__name | font-body-xl fw-400">{capitalize((el.subsidiaryDescription + '').toLowerCase())}</h4>
					}
					{el.address && (
						<>
							<div className="store-info__address-distance-container | display-flex justify-content-between align-items-start w-100">
								<div className="store-info__address-container | display-flex">
									<div className="subsidiary-info-card-address-icon"/>
									<div className="store-info__address | font-body-l fw-400">
										{capitalize((el.address + '').toLowerCase())}, {el.zipCode}, {capitalize((el.cityDescription + '').toLowerCase())} <span>{el.c_provincia}</span>
									</div>
								</div>
								{el.distance &&
									<p className="store-info__distance | font-body-l fw-400 display-none display-desktop-block" title={el.distance}>
										{(el.distance + ' ').replace('.', ',')}
									</p>
								}
							</div>
							<div className="store-info__route">
								{linkIndicazioniStradali &&
									<Button
										className="directions"
										variant="outlined"
										onClick={() =>
											goToLink(linkIndicazioniStradali, '_blank')
										}
									>
										{translations.Directions}
									</Button>
								}
								{el.distance &&
									<span className="store-info__distance-mobile | font-body-l fw-400 display-desktop-none" title={el.distance}>
										- {(el.distance + ' ').replace('.', ',')}
									</span>
								}
							</div>
						</>
					)}
					<div className={"orari-contatti " + el.subsdiaryType}>

						{(
							(el.subsdiaryType === "FILIALE" ) ||
							(el.subsdiaryType === "CP") ||
							(el.subsdiaryType === "CI")
						) && (
								<>
									<div className="row horizontal contacts" style={{fontWeight: 400}}>
										{el.contacts.phone && (
											<a
												href={'tel:' + el.contacts.phone}
												className="phone"
												style={{fontWeight: 400}}
											>
												{el.contacts.phone}
											</a>
										)}
										{el.contacts.fax && (
											<a href={'fax:' + el.contacts.fax} className="fax" style={{fontWeight: 400}}>
												{el.contacts.fax}
											</a>
										)}
										{
											/*
											el.contacts.email && (
												<a href={'mailto:' + el.contacts.email} className="email">
													{el.contacts.email}
												</a>
											)
											*/
										}
									</div>
								</>
							)}
							{false && (
								<>
									{
										stringOpenTime && <div className="row string-open-time" >{parseHTML(stringOpenTime.toString())}</div>
									}
									{
										el.cashLight &&
										<div className="row">
														<span className="small">
															{el.cashLight}
														</span>
										</div>
									}
								</>
							)}
						{(
							(el.subsdiaryType === "FILIALE" ) ||
							(el.subsdiaryType != "CP")
						) &&  el.timetables  && (
								<>
									<div className="row horizontal orari-wrapper">
										<div className="orari-content">
											{sameLunediVenerdi ? (
												<>
													<div className="subsidiary-item-orari-apertura bper-clock">
														<div className="subsidiary-item-giorni-label">{translations.MondayFriday}</div>
															{
																el.timetables && el.timetables.openMondayMorning.split(
																	' '
																)[0]
															}
														/
														{
															el.timetables && el.timetables.openMondayMorning.split(
																' '
															)[1]
														}
														&nbsp;-&nbsp;
														{
															el.timetables && el.timetables.openMondayAfternoon.split(
																' '
															)[0]
														}
														/
														{
															el.timetables && el.timetables.openMondayAfternoon.split(
																' '
															)[1]
														}
													</div>
												</>
											) : (
													<>
														<b  style={{fontWeight:"700"}}>{translations.Monday}</b>
														<ul>
															{el.timetables && el.timetables.openMondayMorning.trim() ===
																'chiuso' &&
																el.timetables && el.timetables.openMondayAfternoon.trim() ===
																'chiuso' ? (
																	<li>{translations.close}</li>
																) : (
																	<>
																		{el.timetables && el.timetables.openMondayMorning !==
																			'chiuso' ? (
																				<li>
																					{
																						el.timetables && el.timetables.openMondayMorning.split(
																							' '
																						)[0]
																					}
																-
																					{
																						el.timetables && el.timetables.openMondayMorning.split(
																							' '
																						)[1]
																					}
																				</li>
																			) : (
																				<li>
																					{translations.close}
																				</li>
																			)}
																		{el.timetables && el.timetables.openMondayAfternoon !==
																			'chiuso' ? (
																				<li>
																					{
																						el.timetables && el.timetables.openMondayAfternoon.split(
																							' '
																						)[0]
																					}
																-
																					{
																						el.timetables && el.timetables.openMondayAfternoon.split(
																							' '
																						)[1]
																					}
																				</li>
																			) : (
																				<li>
																					{translations.close}
																				</li>
																			)}
																	</>
																)}
														</ul>

														<b  style={{fontWeight:"700"}}>{translations.Tuesday}</b>
														<ul>
															{el.timetables && el.timetables.openTuesdayMorning.trim() ===
																'chiuso' &&
																el.timetables && el.timetables.openTuesdayAfternoon.trim() ===
																'chiuso' ? (
																	<li>{translations.close}</li>
																) : (
																	<>
																		{el.timetables && el.timetables.openTuesdayMorning ? (
																			<li>
																				{
																					el.timetables && el.timetables.openTuesdayMorning.split(
																						' '
																					)[0]
																				}
																-
																				{
																					el.timetables && el.timetables.openTuesdayMorning.split(
																						' '
																					)[1]
																				}
																			</li>
																		) : (
																				<li>
																					{translations.close}
																				</li>
																			)}
																		{el.timetables && el.timetables.openTuesdayAfternoon ? (
																			<li>
																				{
																					el.timetables && el.timetables.openTuesdayAfternoon.split(
																						' '
																					)[0]
																				}
																-
																				{
																					el.timetables && el.timetables.openTuesdayAfternoon.split(
																						' '
																					)[1]
																				}
																			</li>
																		) : (
																				<li>
																					{translations.close}
																				</li>
																			)}
																	</>
																)}
														</ul>
														<b  style={{fontWeight:"700"}}>{translations.Wednesday}</b>
														<ul>
															{el.timetables && el.timetables.openWednesdayMorning.trim() ===
																'chiuso' &&
																el.timetables && el.timetables.openWednesdayAfternoon.trim() ===
																'chiuso' ? (
																	<li>{translations.close}</li>
																) : (
																	<>
																		{el.timetables && el.timetables.openWednesdayMorning ? (
																			<li>
																				{
																					el.timetables && el.timetables.openWednesdayMorning.split(
																						' '
																					)[0]
																				}
																-
																				{
																					el.timetables && el.timetables.openWednesdayMorning.split(
																						' '
																					)[1]
																				}
																			</li>
																		) : (
																				<li>
																					{translations.close}
																				</li>
																			)}
																		{el.timetables && el.timetables.openWednesdayAfternoon ? (
																			<li>
																				{
																					el.timetables && el.timetables.openWednesdayAfternoon.split(
																						' '
																					)[0]
																				}
																-
																				{
																					el.timetables && el.timetables.openWednesdayAfternoon.split(
																						' '
																					)[1]
																				}
																			</li>
																		) : (
																				<li>
																					{translations.close}
																				</li>
																			)}
																	</>
																)}
														</ul>
														<b style={{fontWeight:"700"}}>{translations.Thursday}</b>
														<ul>
															{el.timetables && el.timetables.openThursdayMorning.trim() ===
																'chiuso' &&
																el.timetables && el.timetables.openThursdayAfternoon.trim() ===
																'chiuso' ? (
																	<li>{translations.close}</li>
																) : (
																	<>
																		{el.timetables && el.timetables.openThursdayMorning ? (
																			<li>
																				{
																					el.timetables && el.timetables.openThursdayMorning.split(
																						' '
																					)[0]
																				}
																-
																				{
																					el.timetables && el.timetables.openThursdayMorning.split(
																						' '
																					)[1]
																				}
																			</li>
																		) : (
																				<li>
																					{translations.close}
																				</li>
																			)}
																		{el.timetables && el.timetables.openThursdayAfternoon ? (
																			<li>
																				{
																					el.timetables && el.timetables.openThursdayAfternoon.split(
																						' '
																					)[0]
																				}
																-
																				{
																					el.timetables && el.timetables.openThursdayAfternoon.split(
																						' '
																					)[1]
																				}
																			</li>
																		) : (
																				<li>
																					{translations.close}
																				</li>
																			)}
																	</>
																)}
														</ul>
														<b style={{fontWeight:"700"}}>{translations.Friday}</b>
														<ul>
															{el.timetables && el.timetables.openFridayMorning.trim() ===
																'chiuso' &&
																el.timetables && el.timetables.openFridayAfternoon.trim() ===
																'chiuso' ? (
																	<li>{translations.close}</li>
																) : (
																	<>
																		{el.timetables && el.timetables.openFridayMorning ? (
																			<li>
																				{
																					el.timetables && el.timetables.openFridayMorning.split(
																						' '
																					)[0]
																				}
																-
																				{
																					el.timetables && el.timetables.openFridayMorning.split(
																						' '
																					)[1]
																				}
																			</li>
																		) : (
																				<li>
																					{translations.close}
																				</li>
																			)}
																		{el.timetables && el.timetables.openFridayAfternoon ? (
																			<li>
																				{
																					el.timetables && el.timetables.openFridayAfternoon.split(
																						' '
																					)[0]
																				}
																-
																				{
																					el.timetables && el.timetables.openFridayAfternoon.split(
																						' '
																					)[1]
																				}
																			</li>
																		) : (
																				<li>
																					{translations.close}
																				</li>
																			)}
																	</>
																)}
														</ul>
													</>
												)}
											{
												el.cashLight &&
												<div className="row subsidiary-item-open-info">
														({el.cashLight})
												</div>
											}
											{sameSabatoDomenicaChiuso ? (
												<>
												</>
											) : (
													<>
													<div className="subsidiary-item-orari-apertura">
														<div className="subsidiary-item-giorni-label">{translations.Saturday}</div>
															{el.timetables && el.timetables.openSaturdayMorning.trim() ===
																'chiuso' &&
																el.timetables && el.timetables.openSaturdayAfternoon.trim() ===
																'chiuso' ? (
																	<li>{translations.close}</li>
																) : (
																	<>
																		{el.timetables && el.timetables.openSaturdayMorning ? (
																			<li>
																				{
																					el.timetables && el.timetables.openSaturdayMorning.split(
																						' '
																					)[0]
																				}
																-
																				{
																					el.timetables && el.timetables.openSaturdayMorning.split(
																						' '
																					)[1]
																				}
																			</li>
																		) : (
																				<li>
																					{translations.close}
																				</li>
																			)}
																		{el.timetables && el.timetables.openSaturdayAfternoon ? (
																			<li>
																				{
																					el.timetables && el.timetables.openSaturdayAfternoon.split(
																						' '
																					)[0]
																				}
																-
																				{
																					el.timetables && el.timetables.openSaturdayAfternoon.split(
																						' '
																					)[1]
																				}
																			</li>
																		) : (
																				<li>
																					{translations.close}
																				</li>
																			)}
																	</>
																)}
														<b style={{fontWeight:"700"}}>{translations.Sunday}</b>
														<ul>
															{el.timetables && el.timetables.openSundayMorning.trim() ===
																'chiuso' &&
																el.timetables && el.timetables.openSundayAfternoon.trim() ===
																'chiuso' ? (
																	<li>{translations.close}</li>
																) : (
																	<>
																		{el.timetables && el.timetables.openSundayMorning ? (
																			<li>
																				{
																					el.timetables && el.timetables.openSundayMorning.split(
																						' '
																					)[0]
																				}
																-
																				{
																					el.timetables && el.timetables.openSundayMorning.split(
																						' '
																					)[1]
																				}
																			</li>
																		) : (
																				<li>
																					{translations.close}
																				</li>
																			)}
																		{el.timetables && el.timetables.openSundayAfternoon ? (
																			<li>
																				{
																					el.timetables && el.timetables.openSundayAfternoon.split(
																						' '
																					)[0]
																				}
																-
																				{
																					el.timetables && el.timetables.openSundayAfternoon.split(
																						' '
																					)[1]
																				}
																			</li>
																		) : (
																				<li>
																					{translations.close}
																				</li>
																			)}
																	</>
																)}
														</ul>
														</div>
													</>
												)}
										</div>
									</div>
								</>
							)}
					</div>
					{((el.subsdiaryType === "FILIALE") || (el.subsdiaryType === "ATMCSA")) && el.services && (
						<ul className="services">
							{
								el.services.map((service, i) => (
									<>
										<li key={'service_' + service.serviceId} id={"service_" + subsidiaryId + "_" + service.serviceId}>
											<span
												style={{cursor:"pointer"}}
												className="icon"
												onClick={(e) => handleShowServiceInfo("service_" + subsidiaryId + "_" + service.serviceId, e, { serviceId: service.serviceId, itemId: subsidiaryId, abstract: service.popup })}
											>
											<img src={"/documents/"+JSON.parse(service.icon).groupId+"/"+JSON.parse(service.icon).uuid} />
											</span>
											<span style={{ display: "flex", flexDirection: "column",cursor:"pointer" }}>
												<a
													style={{ marginBottom: "3px" }}
													className="text link-cta link-cta-icon green-dark"
													onClick={(e) => handleShowServiceInfo("service_" + subsidiaryId + "_" + service.serviceId, e, { serviceId: service.serviceId, itemId: subsidiaryId, abstract: service.popup })}
												>
													<span className="title">{service.title}</span>
												</a>
												<a
													className="text link-cta green-dark"
													onClick={(e) => handleShowServiceInfo("service_" + subsidiaryId + "_" + service.serviceId, e, { serviceId: service.serviceId, itemId: subsidiaryId, abstract: service.popup })}
												>
													<span className="subtitle">{service.subTitle}</span>
												</a>
											</span>
										</li>
									</>
								))
							}
						</ul>
					)}
				</div>
				<Button
					onClick={(e) => stopPropagation()}
					href={bankCode === 'bankCode-05387' ? 'https://www.bper.it' + el.linkSubsidiaryCard
						: (el.linkSubsidiaryCard ? el.linkSubsidiaryCard.replace("trova-filiali","trova-centri-private-e-filiali") : el.linkSubsidiaryCard)}
					target="_blank"
					className=""
					variant="cta-ghost"
					color=""
				>
					{translations.DiscoverDetail}
				</Button>
			</div>
		</div >
	);
}

export default ResultsItem;
